import styled from 'styled-components';
import { Checkbox } from 'ui/checkboxV2';
import { CHECKBOX_STATUS } from 'ui/checkboxV2/types';
import { pxToRem } from 'utils/convert';
import { useSelectionContext } from '../../../contexts/SelectionContext';
import { TableCell } from './styled';

const StyledCheckbox = styled(Checkbox)`
  margin: 0;
  height: ${pxToRem(18)};
  gap: 0;
`;

const getStatus = (selected: string[] = [], currentPageIds: string[] = []) => {
  if (selected?.length === 0) return false;
  else if (selected?.length === currentPageIds.length) return true;
  return 'indeterminate';
};

export const SelectionHeaderCell = ({ currentPageIds }: { currentPageIds: string[] }) => {
  const { selected = [], selectByIds, deselectAll } = useSelectionContext();

  return (
    <TableCell role="columnheader">
      <StyledCheckbox
        id="select-all"
        label=""
        status={getStatus(selected as string[], currentPageIds) as CHECKBOX_STATUS}
        setChecked={() => {
          if (currentPageIds?.length === selected?.length) {
            deselectAll();
          } else {
            selectByIds(currentPageIds);
          }
        }}
      />
    </TableCell>
  );
};
